import Swiper,  { Navigation, Pagination, FreeMode, Manipulation, Thumbs } from 'swiper'

if ($('.js-gallery-popup').length){
  let gallerySwiper, gallerySwiper2

  $('.js-open-gallery').click(function (){
      let galleryBlock = $(this).closest('.js-gallery-block')
    let galleryPopup = $('.js-gallery-popup')
    let galleryData = galleryBlock
    let slides = galleryData.find('.img')
    let bigSlider = $('.js-gallery-slider-big')
    let navSlider = $('.js-gallery-slider-nav')
    let initialSlide = $(this).data('initial-slide')
    let galleryTitle = galleryData.data('gallery-title')
    let galleryTitleEl = galleryPopup.find('.js-gallery-title')
    let galleryAuthor = galleryData.data('gallery-author')
    let galleryAuthorEl = galleryPopup.find('.js-gallery-img-author')
    let totalSlidesEl = galleryPopup.find('.js-total-gallery-img')
    let currentSlideEl = galleryPopup.find('.js-current-gallery-img')
    let imgDescriptionEl = galleryPopup.find('.js-gallery-text')

    if (!initialSlide) initialSlide = 0
    bigSlider.find('.swiper-wrapper').empty()
    navSlider.find('.swiper-wrapper').empty()


    // fill popup with gallery info
    totalSlidesEl.html(slides.length)
    currentSlideEl.html(initialSlide + 1)

    if (galleryTitle){
      galleryTitleEl.html(galleryTitle).show()
    } else {
      galleryTitleEl.hide()
    }
    if (galleryAuthor){
      galleryAuthorEl.html(galleryAuthor)
      galleryAuthorEl.parent().show()
    } else {
      galleryAuthorEl.parent().hide()
    }
    setSlideDescription(initialSlide)

    // add gallery images
    slides.each(function(i, el){
      // Prepare big slide html
      let bigEl = '<img src="'+ $(el).data('src') +'" />';

      if ($(el).data('video')) {
        bigEl = '<video width="400" controls>'+
                                  '<source src="'+ $(el).data('video') +'" type="video/mp4">'+
                                '</video>';
      }

      if ($(el).data('youtube-video')) {
        bigEl = '<iframe data-img-src="'+ $(el).data('youtube-video') +'" src="" ' +
                        'title="YouTube video player" frameborder="0" allowfullscreen '+
                    'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"'+
                '</iframe>';
      }

      bigSlider.find('.swiper-wrapper').append('<div class="swiper-slide">'+ bigEl +'</div>');

      // Prepare nav slide html
      // let navEl = '<div class="img" style="background: url('+$(el).data('src')+') no-repeat center; background-size:cover;"></div>';
      // navSlider.find('.swiper-wrapper').append('<div class="swiper-slide">'+ navEl +'</div>');
    })


    // gallerySwiper = new Swiper(".js-gallery-slider-nav", {
    //   modules: [Navigation, Pagination, FreeMode, Manipulation, Thumbs],
    //   //loop: true,
    //   spaceBetween: 10,
    //   slidesPerView: 2,
    //   freeMode: true,
    //   watchSlidesProgress: true,
    //   breakpoints: {
    //       200: {
    //       slidesPerView: 3,
    //     },
    //     500: {
    //       slidesPerView: 4,
    //     },
    //     800: {
    //       slidesPerView: 5,
    //       spaceBetween: 15,
    //     },
    //     1200: {
    //       slidesPerView: 6,
    //     },
    //   },
    // });

    gallerySwiper2 = new Swiper(".js-gallery-slider-big", {
      modules: [Navigation, Pagination, FreeMode, Manipulation, Thumbs],
      //loop: true,
      spaceBetween: 0,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      // thumbs: {
      //   swiper: gallerySwiper,
      // },
      initialSlide: initialSlide,
      on: {
        slideChange: function () {
            // stop prev slide video and play current left slider video
            $(this.el).find('video').each(function(i, el) {
                el.pause()
                el.currentTime = 0
            })
            let curSLide = $(this.slides[this.activeIndex])
            let video = curSLide.find('video')
            if (video.length){
                video[0].play()
            }

            // youtube video
            $(this.el).find('iframe').each(function(i, el) {
                $(this).attr('src', '')
            })
            let iframe = curSLide.find('iframe')
            iframe.attr('src', iframe.attr('data-img-src'))
        },

        },
    });


    gallerySwiper2.on('slideChange', function(){
      currentSlideEl.html(this.activeIndex + 1)
      setSlideDescription(this.activeIndex)
    })


    $('.js-gallery-popup').fadeIn();
    $('body').addClass('modal-open')


    // set slide description
    function setSlideDescription(slideIndex){
      let description = $(slides[slideIndex]).data('description')
      if (description){
        imgDescriptionEl.html(description).show()
      } else {
        imgDescriptionEl.html('').hide()
      }
    }


  })


  $('.js-close-gallery-popup').click(function(){
          $('.js-gallery-popup').fadeOut()
      //gallerySwiper.destroy(1,0)
      gallerySwiper2.destroy(1,0)
        $('body').removeClass('modal-open')
  })

}
